import { useQuery } from '@tanstack/react-query';
import {
  MaintenanceExecutionService,
  type WorkOrderMergeSuggestionsQuery,
} from '~/app/services/maintenance-execution/maintenance-execution.service';

export const workOrderMergeSuggestionsQueryKey = (
  organizationId: string,
  query: Omit<WorkOrderMergeSuggestionsQuery, 'organizationId'> = {},
) =>
  [
    'maintenance-execution',
    'optimizer-suggestions',
    organizationId,
    query.page ?? 1,
    query.limit ?? 20,
    query.siteId ?? null,
    query.isoWeekKey ?? null,
    query.scheduledFrom ?? null,
    query.scheduledTo ?? null,
    query.status ?? null,
  ] as const;

export function useWorkOrderMergeSuggestions(
  organizationId: string,
  query: Omit<WorkOrderMergeSuggestionsQuery, 'organizationId'> = {},
) {
  return useQuery({
    queryKey: workOrderMergeSuggestionsQueryKey(organizationId, query),
    queryFn: () =>
      MaintenanceExecutionService.getMergeSuggestions({
        organizationId,
        ...query,
      }),
    enabled: Boolean(organizationId),
  });
}
